// src/layouts/Pages/PageHeader/CardHeaderColumns/items/cnpj.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { FileProtectOutlined } from '@ant-design/icons';
import { parseCnpjToDisplay, returnOnlyNumbers } from 'utils/helpers';
import translateX from 'utils/translateX';
import appService from 'services/appService';

// *******************************************************************************
// ITEM FUNCTION
// *******************************************************************************
export const cnpjItem = record => {
  const cnpj = parseCnpjToDisplay(record?.cnpj?.value);

  return {
    key: 'cnpj',
    icon: <FileProtectOutlined />,
    label: cnpj,
    tooltipText: translateX('cnpj'),
    tooltipPlacement: 'right',
    onClick: cnpj
      ? () => appService.handleCopyToClipboard(returnOnlyNumbers(cnpj), 'cnpj_copied')
      : null,
  };
};

export default cnpjItem;
